<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import Swal from "sweetalert2";
export default {
    props: {
        data: Object,
        publicPostOptions: Object
    },
    components: {
        LoadingTemplate,
        UploadPopover
    },
    data(){
        return {
            selectedPost: null,
            attachmentForPushing: null
        }
    },
    computed: {
        filteredPosts(){
            let data = this.data.posts;
            if(this.data.fileSearch && this.data.fileSearch != ""){
                data = data.filter(x => x.searchKey.toLowerCase().includes(this.data.fileSearch.toLowerCase()))
            }
            return data;
        }
    },
    methods: {
        addPublicPost(){
            this.$emit('addPublicPost');
        },
        uploadedPublicPostAttachment(file, parent){
            this.selectedPost = parent;
            this.attachmentForPushing = file;
        },
        closePublicPostAttachment(post){
            post.showAttachment = false;
            if(!this.selectedPost) return;
            this.selectedPost.attachments.push(this.attachmentForPushing);
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        removePublicPostAttachment(file, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", file.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let fileIndex = parent.attachments.findIndex(x => x.id == file.id);
                            parent.attachments.splice(fileIndex, 1);
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        deletePublicAttachment(row){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("rfqpostingfile/DeleteRfqPostingFile", row.id)
                        .then(() => {
                            let index = this.data.posts.findIndex((item) => item.id == row.id);
                            this.data.posts.splice(index, 1);
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        async updatePublicAttachment(row){
            this.$emit('updatePublicAttachment', row);
        },
    }
}
</script>
<template>
  <div>
        <div class="d-flex align-items-center justify-content-between mb-2">
            <input
                type="search"
                class="form-control popover-report"
                v-model="data.fileSearch"
                placeholder="Search Public Post Attachments..."
            />
            <button type="button" class="btn btn-outline-info" @click="addPublicPost"><i class="bx bx-plus"></i>Add Public Post Attachment</button>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th width="250px">Attachment</th>
                        <th width="90px">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!data.postLoading && data.posts.length == 0">
                        <td colspan="4" class="text-center">No data found</td>
                    </tr>
                    <tr v-if="data.postLoading">
                        <td colspan="4" class="text-center">
                            <LoadingTemplate />
                        </td>
                    </tr>
                    <template v-if="!data.postLoading && data.posts.length > 0">
                        <tr v-for="post in filteredPosts" :key="post.id">
                            <td>{{post.title}}</td>
                            <td>{{post.description}}</td>
                            <td>
                                <div v-if="post.attachments.length > 0">
                                    <div v-for="attachment in post.attachments" :key="attachment.id" class="d-inline-block">
                                        <div class="d-flex hover-toggle align-items-center">
                                            <a href="javascript:void(0);" class="text-normal-color hoverable-link me-1" @click="openDocument(attachment)"><i>{{attachment.description}}</i></a>
                                            <span class="hover-content"><i class="bx bx-trash cursor-pointer text-danger" @click="removePublicPostAttachment(attachment, post)"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <a href="javascript:void(0);" class="hoverable-link" :id="`attachment-document${post.id}`" @click="post.showAttachment = true">
                                        <i class="bx bx-plus me-1"></i>Add Attachments
                                    </a>
                                    <upload-popover
                                        :option="publicPostOptions"
                                        :sourceId="post.id"
                                        @uploaded="uploadedPublicPostAttachment($event, post)"
                                        :showPV="post.showAttachment"
                                        @closePopover="closePublicPostAttachment(post)"
                                        :dzId="`dropzone-attachment${post.id}`"
                                        :pvId="`attachment-document${post.id}`"
                                    ></upload-popover>
                                </div>
                            </td>
                            <td class="text-center">
                                <a href="javascript:void(0);" class="text-success font-size-16 me-2" title="Update" @click="updatePublicAttachment(post)"><i class="bx bx-edit"></i></a>
                                <a href="javascript:void(0);" class="text-danger font-size-16" title="Delete" @click="deletePublicAttachment(post)"><i class="bx bx-trash"></i></a>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
  </div>
</template>